import { AppShell } from "@/components/AppShell";
import { AppTopChrome } from "@/components/AppTopChrome";
import { AutoPilot } from "@/components/AutoPilot";
import ProxyMetricsPage from "@/pages/ProxyMetricsPage";

import { useApp } from "@/context/AppCtx";

export function TradingWorkspace() {
  const { activitySection } = useApp() as any;

  return (
    <div className="flex h-full min-h-[100dvh] min-h-0 flex-col overflow-hidden bg-[var(--color-bg-editor)]">
      <AutoPilot />
      <AppTopChrome />
      {activitySection === "proxy" ? (
        <div className="flex-1 w-full overflow-y-auto bg-[#1a1a2e]">
          <ProxyMetricsPage />
        </div>
      ) : (
        <AppShell />
      )}
    </div>
  );
}
